import { useRef, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Box from 'ui/src/components/Box'
import Typography from 'ui/src/components/Typography'
import Avatar from 'ui/src/components/Avatar'
import { IRegister } from 'models/register.model'

interface PersonalAccountProps {
  userAvatar: string
  isProfileMenuOpen: boolean
  setIsProfileMenuOpen: (isProfileMenuOpen: boolean) => void
  profileSelected: 'individual' | 'company'
  register?: IRegister | undefined
}

const PersonalAccount = ({
  userAvatar,
  setIsProfileMenuOpen,
  profileSelected,
  register,
}: PersonalAccountProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)

  const handleModalClose = useCallback(() => {
    setIsProfileMenuOpen(false)
  }, [setIsProfileMenuOpen])

  const userRegistered = useMemo(() => {
    if (!register) return false
    const hasHistory = Array.isArray(register.scoreHistory) && register.scoreHistory.length > 0
    const hasMFA = typeof register.useMFA === 'boolean'
    return hasHistory && hasMFA
  }, [register])

  const handleClick = useCallback(() => {
    navigate(userRegistered ? '/dashboard' : '/userform')
    handleModalClose()
  }, [userRegistered, navigate, handleModalClose])

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '0.75rem',
        cursor: 'pointer',
      }}
    >
      <Avatar sx={{ width: '1.5rem', height: '1.5rem' }} src={userAvatar} />
      <Typography
        onClick={handleClick}
        variant={profileSelected === 'individual' ? 'subtitle1' : 'body3'}
      >
        {t('default.profileMenu.personalAccount')}
      </Typography>
    </Box>
  )
}

export default PersonalAccount
